import { Typography, Link as MuiLink, Box, Button, Paper, Stack, Tooltip } from '@mui/material'
import { ZapierZap } from '@sendhub/integrations/api-client-typescript-axios'
import Image from 'mui-image'

export type ZapierZapProps = {
  zap: Readonly<ZapierZap>
  onClick: () => void
}
export function ZapierZapRow({ zap, onClick }: ZapierZapProps) {
  const zapEditorLink = `https://zapier.com/app/editor/${zap.id}?provider=sendhub`
  // console.log('zap:', zap)
  return (
    <MuiLink
      underline="none"
      href={zapEditorLink}
      key={zapEditorLink}
      target="_blank"
      onClick={(event) => {
        event.preventDefault()
        onClick()
      }}
    >
      <Paper
        sx={{
          p: 2,
          marginY: 0.5,
          display: 'flex',
          flexDirection: {
            xs: 'column',
            sm: 'row',
            md: 'row',
            // lg: 'none',
            // xl: 'none',
          },
          ':hover': {
            outlineWidth: 1,
            outlineStyle: 'solid',
          },
        }}
      >
        {/* Step Icons */}
        <Tooltip title={zap.steps.map((step) => step.app?.title || 'Empty Step' /** 'SendHub' */).join(', ')} placement="bottom">
          <Stack direction="row" spacing={1}>
            {zap.steps.map((step, index) => (
              <Box
                key={index}
                sx={{
                  width: '40px',
                  height: '40px',
                  outlineWidth: '1px',
                  outlineColor: 'lightgrey',
                  outlineStyle: 'solid',
                  borderRadius: 'inherit',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',

                  '& .MuiCircularProgress-root': {
                    width: '100% !important',
                    height: '100% !important',
                  },
                }}
              >
                <Image
                  src={
                    step.app?.image || ''
                    // 'https://zapier-images.imgix.net/storage/developer/8c3ec82a6a32315c165e0e9c70a167b6.png?auto=format%2Ccompress&fit=crop&h=32&ixlib=python-3.0.0&q=50&w=32'
                  }
                  height="30px"
                  width="30px"
                  fit="scale-down"
                  duration={600}
                  easing="cubic-bezier(0.7, 0, 0.6, 1)"
                  showLoading={true}
                  errorIcon={true}
                  shift="top"
                  distance="20px"
                  shiftDuration={180}
                  bgColor="inherit"
                />
              </Box>
            ))}
          </Stack>
        </Tooltip>

        {/* Title */}
        <Typography variant="body1" sx={{ fontWeight: 'bold', marginX: 1, flexGrow: 1 }}>
          {zap.title || 'Untitled Zap'}
        </Typography>

        {/* On / Off */}
        <Box sx={{ width: '70px', display: 'flex', justifyContent: 'center' }}>
          <Typography
            sx={{
              padding: '5px 10px',
              fontSize: '.9rem',
              fontWeight: 'bold',
              borderRadius: '20px',
              color: 'white',
              backgroundColor: zap.state === 'on' ? (theme) => theme.palette.primary.main : (theme) => theme.palette.grey['700'],
              alignSelf: 'center',
              textTransform: 'uppercase',
              width: 'fit-content',
              minWidth: '3rem',
              textAlign: 'center',
            }}
          >
            {zap.state}
          </Typography>
        </Box>
      </Paper>
    </MuiLink>
  )
}
